import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 104px;
  border-top: 1px solid #ccdae9;
  margin-top: 80px;
  align-items: center;
  justify-content: center;
`;

interface CopyrightsProps {
  Color?: string;
  Cursor?: 'pointer' | 'default' | 'wait' | 'text' | 'move' | 'help' | 'none';
}

export const Copyrights = styled.p<CopyrightsProps>`
  color: ${(props) => props.Color || '#5c7199'};
  font-size: 12px;
  cursor: ${(props) => props.Cursor || 'default'}; // Provided a default
`;

export const SeparationLine = styled.div`
  border-right: 1px solid #ccdae9;
  height: 12px;
  width: 1px;
  margin: 0 8px;
`;